import { SetStateAction, useCallback, useEffect, useState } from "react";
import { IStandardsModalConfirmData } from "@/search/Langston/types/IStandardsModalConfirmData";
import { IStandardsSetListViewModel } from "@/search/Langston/types/IStandardsSetListViewModel";
import { IStandardsModalTab } from "@/search/Langston/types/IStandardsModalTab";

export const useStandardsModalTabsNavigation = (
  createdStandardsSets: IStandardsSetListViewModel[],
  setConfirmModalData: (
    value: SetStateAction<IStandardsModalConfirmData>,
  ) => void,
  modalTabs: IStandardsModalTab[],
) => {
  const [allowModalTabAutoChanges, setAllowModalTabAutoChanges] =
    useState(false);

  const getStandardsSetIndexFromTab = (activeTab: HTMLElement | null) => {
    if (activeTab) {
      const tabButton = activeTab.children[0];
      if (tabButton) {
        const tabButtonId = (tabButton as HTMLElement).id.split("_")[0];
        return tabButtonId;
      }
    }
    return undefined;
  };

  const switchEditDataOnTabChange = useCallback(
    (activeTab: HTMLElement | null) => {
      const standardsSetId = getStandardsSetIndexFromTab(activeTab);
      if (standardsSetId) {
        const currentStandardsSetIndex = createdStandardsSets.findIndex(
          (set) => set.id === standardsSetId,
        );
        if (currentStandardsSetIndex !== -1) {
          const currentStandardsSet =
            createdStandardsSets[currentStandardsSetIndex];
          if (currentStandardsSet) {
            setConfirmModalData({
              setId: currentStandardsSet.id,
              editData: { ...currentStandardsSet },
            });
          }
        }
      }
    },
    [createdStandardsSets, setConfirmModalData],
  );

  const goToStandardsSetTab = useCallback(() => {
    if (modalTabs.length > 0) {
      const standardsSetsTabs = modalTabs.slice(1, modalTabs.length - 1);
      const numberOfStandardsSets = standardsSetsTabs.length;
      if (numberOfStandardsSets > 0) {
        const latestCreatedStandardsSet =
          standardsSetsTabs[numberOfStandardsSets - 1];
        if (latestCreatedStandardsSet) {
          const buttonId = `${latestCreatedStandardsSet.panelId}_tab`;
          const button = document.getElementById(buttonId);
          if (button) {
            button.click();
            const currentStandardsSet = createdStandardsSets.find(
              (set) => set.id === latestCreatedStandardsSet.panelId,
            );
            if (currentStandardsSet) {
              setConfirmModalData({
                setId: currentStandardsSet.id,
                editData: currentStandardsSet,
              });
            }
          }
        }
      } else {
        const allButton = document.getElementById("all_tab");
        if (allButton) {
          allButton.click();
        }
      }
    }
  }, [createdStandardsSets, setConfirmModalData, modalTabs]);

  useEffect(() => {
    if (allowModalTabAutoChanges) {
      goToStandardsSetTab();
    }
  }, [modalTabs.length]);

  return {
    goToStandardsSetTab,
    switchEditDataOnTabChange,
    allowModalTabAutoChanges,
    setAllowModalTabAutoChanges,
  };
};
